import { useMutation } from '@tanstack/react-query';
import { passwordResetApi } from '../api/passwordReset.api';

/**
 * Mutation: POST /api/eraf/auth/password-reset/request
 * Always succeeds (200) regardless of email existence.
 * Rate-limit (429) propagates as error.
 */
export function usePasswordResetRequest() {
  return useMutation({
    mutationKey: ['passwordReset', 'request'],
    mutationFn: (email: string) =>
      passwordResetApi.request({ email }),
  });
}
